<template>
    <Button label="Atualizar" icon="pi pi-pencil" class="ml-2" @click="toAtualizar()" v-if="$temAcessoView('CHECKINS-EVENTOS-05')" />
</template>

<script>
export default {
    props: {
        evento: {
            type: Object,
        },
    },

    methods: {
        toAtualizar() {
            this.$router.push({
                name: 'Checkins_Eventos_AtendimentoDetalhe_Atualizar',
                params: {
                    id: this.evento.eventoId,
                },
            });
        },
    },
};
</script>
